const getFieldValidationObject = () => ({
  required: false,
  pattern: '',
})

export default getFieldValidationObject
